import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { isNative } from "./platform";
import { haptics } from "./haptics";
import "./Dialog.scss";

// On native, add bottom-sheet styling to all dialogs
const nativeClass = isNative() ? {
	popup: 'bottom-sheet',
} : {};

// Map SweetAlert2 `icon` prop to a haptic intensity — error/warning buzz,
// success double-tap, info/question stay silent. didOpen runs once per fire().
const hapticForIcon = {
	error: () => haptics.error(),
	warning: () => haptics.error(),
	success: () => haptics.success(),
};

const Dialog = withReactContent(
	Swal.mixin({
		buttonsStyling: false,
		customClass: {
			confirmButton: 'btn btn-primary',
			denyButton: 'btn btn-outline-secondary',
			cancelButton: 'btn btn-outline-secondary',
			...nativeClass,
		},
		didOpen: (el) => {
			const icon = el?.querySelector('.swal2-icon')?.classList;
			const kind = icon?.contains('swal2-error') ? 'error'
				: icon?.contains('swal2-warning') ? 'warning'
				: icon?.contains('swal2-success') ? 'success'
				: null;
			if (kind) hapticForIcon[kind]?.();
		},
	})
);

export default Dialog;
